"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ButtonStyle = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Button = /*#__PURE__*/_react.default.forwardRef(({
  className,
  type = 'button',
  children,
  ...rest
}, ref) => {
  return /*#__PURE__*/_react.default.createElement("button", _extends({
    className: className,
    type: type
  }, rest, {
    ref: ref
  }), children);
});

const ButtonStyle = (0, _styledComponents.css)(["background:", ";border:0;color:#fff;cursor:pointer;height:48px;padding:0 24px;margin:16px 0;line-height:48px;font-weight:300;border-radius:4px;", ";", " ", ""], p => p.err ? p.theme.colors.err : p.theme.colors.main, p => p.theme.transition, p => !p.secondary && (0, _styledComponents.css)(["", ";", ""], p => !p.err && (0, _styledComponents.css)(["   &:hover{background:#555;box-shadow:0 2px 4px rgba(0,0,0,0.3);}&:disabled{background:#ccc !important;cursor:default;}"]), p => p.err && (0, _styledComponents.css)(["cursor:default;"])), p => p.secondary && (0, _styledComponents.css)(["background:transparent;color:#555;&:hover:not(:disabled){color:#222;background:#f7f8f2;}&:disabled{background:#f2f2f2;color:#ccc;cursor:default;}"]));
exports.ButtonStyle = ButtonStyle;

var _default = (0, _styledComponents.default)(Button).withConfig({
  displayName: "Button",
  componentId: "sc-1ulka7n-0"
})(["", ""], ButtonStyle);

exports.default = _default;